import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { api } from '../utils/api'

export default function AuthScreen() {
  const [activeTab, setActiveTab] = useState<'ldap' | 'invite'>('ldap')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const login = useAuthStore((s) => s.login)
  const navigate = useNavigate()

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      if (activeTab === 'ldap') {
        const res = await api.post('/api/auth/login', {
          username,
          password,
        })
        login(res.data.role, username, res.data.access_token)
      } else {
        const res = await api.post('/api/auth/login', { code })
        login(res.data.role, res.data.username || '', res.data.access_token)
      }
      navigate('/', { replace: true })
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Ошибка авторизации')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-bg-app">
      <div className="w-full max-w-[420px] p-8 bg-bg-panel border border-border rounded-sm text-center animate-fade-in">
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">
            <span className="text-accent font-bold">DC</span>{' '}
            <span className="font-mono font-normal opacity-80">Cable Link</span>
          </h2>
          <p className="text-text-secondary text-sm">Система расчёта и трассировки кабелей</p>
        </div>

        <div className="flex mb-6">
          <button
            onClick={() => setActiveTab('ldap')}
            className={`flex-1 py-2 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'ldap'
                ? 'border-accent text-text-primary'
                : 'border-transparent text-text-muted'
            }`}
          >
            LDAP
          </button>
          <button
            onClick={() => setActiveTab('invite')}
            className={`flex-1 py-2 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'invite'
                ? 'border-accent text-text-primary'
                : 'border-transparent text-text-muted'
            }`}
          >
            Код доступа
          </button>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          {activeTab === 'ldap' ? (
            <>
              <div>
                <label htmlFor="ldap-username" className="block text-sm text-text-secondary mb-1">Имя пользователя</label>
                <input
                  id="ldap-username"
                  name="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full px-4 py-2.5 bg-bg-input border border-border rounded-sm text-text-primary focus:border-accent outline-none"
                  placeholder="ivanov.i"
                  required
                />
              </div>
              <div>
                <label htmlFor="ldap-password" className="block text-sm text-text-secondary mb-1">Пароль</label>
                <input
                  id="ldap-password"
                  name="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-2.5 bg-bg-input border border-border rounded-sm text-text-primary focus:border-accent outline-none"
                  placeholder="••••••••"
                  required
                />
              </div>
            </>
          ) : (
            <div>
              <label htmlFor="invite-code" className="block text-sm text-text-secondary mb-1">Код доступа</label>
              <input
                id="invite-code"
                name="invite_code"
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                className="w-full px-4 py-2.5 bg-bg-input border border-border rounded-sm text-text-primary focus:border-accent outline-none"
                placeholder="DC-XXXX-XXXX"
                required
              />
              <small className="text-text-muted text-xs mt-1 block">
                Введите инвайт-код, полученный от администратора
              </small>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 bg-accent text-white rounded-sm font-medium hover:bg-accent-hover transition-colors disabled:opacity-50"
          >
            {loading ? 'Вход...' : 'Войти'}
          </button>

          {error && <p className="text-status-critical text-sm mt-3">{error}</p>}
        </form>
      </div>
    </div>
  )
}
